import React from 'react';

type AnswerHistoryConfig = {
  disabled: boolean;
};

export const AnswerHistoryContext = React.createContext<AnswerHistoryConfig>({
  disabled: false,
});

export const useAnswerHistoryConfig = () =>
  React.useContext(AnswerHistoryContext);
